import React from "react";
import {
    TbLetterA,
    TbLetterB,
    TbLetterC,
    TbLetterD,
    TbLetterE,
    TbLetterF,
    TbLetterG,
    TbLetterH,
    TbLetterI,
    TbLetterJ,
    TbLetterK,
    TbLetterL,
    TbLetterM,
    TbLetterN,
    TbLetterO,
    TbLetterP,
    TbLetterQ,
    TbLetterR,
    TbLetterS,
    TbLetterT,
    TbLetterU,
    TbLetterV,
    TbLetterW,
    TbLetterX,
    TbLetterY,
    TbLetterZ,
} from "react-icons/tb";

const LETTER_ICONS = {
    a: TbLetterA,
    b: TbLetterB,
    c: TbLetterC,
    d: TbLetterD,
    e: TbLetterE,
    f: TbLetterF,
    g: TbLetterG,
    h: TbLetterH,
    i: TbLetterI,
    j: TbLetterJ,
    k: TbLetterK,
    l: TbLetterL,
    m: TbLetterM,
    n: TbLetterN,
    o: TbLetterO,
    p: TbLetterP,
    q: TbLetterQ,
    r: TbLetterR,
    s: TbLetterS,
    t: TbLetterT,
    u: TbLetterU,
    v: TbLetterV,
    w: TbLetterW,
    x: TbLetterX,
    y: TbLetterY,
    z: TbLetterZ,
};

export const GetIcon = ({ billTemplateName, ...props }) => {
    const letter = (billTemplateName || "").toLowerCase()[0];
    const Icon = letter ? LETTER_ICONS[letter] : null;
    if (!Icon) return <></>;
    return <Icon {...props} />;
};
